import flowRight from 'lodash/flowRight';
import React, { createContext, useContext } from 'react';
import { connect } from 'react-redux';
import { withCustomMetrics } from '@zocdoc-frontend-common/utils-frontend-metrics';
import { CreateUsernameFormContext } from 'src/Booking/components/CreateUsernameForm/CreateUsernameFormProvider';
import { PatientInfoFormContext } from '../../components/PatientInfoForm/PatientInfoFormProvider';
import { INITIAL_BOOKING_ROOT_KEY } from '../../constants';
import useCreatePasswordForm from './useCreatePasswordForm';

export const CreatePasswordFormContext = createContext();

const CreatePasswordFormProvider = ({
    children,
    directoryId,
    goBackToPatientInfo,
    goBackToPreviousPage,
    onSubmitSuccess,
    sendMetric,
}) => {
    const patientInfoContext = useContext(PatientInfoFormContext);
    const createUsernameContext = useContext(CreateUsernameFormContext);

    const createPasswordForm = useCreatePasswordForm({
        createUsernameContext,
        goBackToPatientInfo,
        goBackToPreviousPage,
        onSubmitSuccess: onSubmitSuccess,
        patientInfoContext,
        sendMetric,
        directoryId,
    });

    return (
        <CreatePasswordFormContext.Provider value={createPasswordForm}>
            {children}
        </CreatePasswordFormContext.Provider>
    );
};

const mapStateToProps = (state = {}) => {
    const bookingPage = state[INITIAL_BOOKING_ROOT_KEY];

    return {
        directoryId: bookingPage?.directoryId,
    };
};

export default flowRight(
    connect(mapStateToProps),
    withCustomMetrics({
        category: 'Booking - Create Password',
        page: 'Booking',
        section: 'Create Password View',
        component: 'Create Password Form',
        element: 'Create Password Form',
    })
)(CreatePasswordFormProvider);
